import { apiSlice } from "./apiSlice";

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    login: builder.mutation({
      query: credentials => ({
        url: 'signin',
        method: 'post',
        body: credentials
      })
    }),
    impersonate: builder.mutation({
      query: personaId => ({
        url: `signin-as/${personaId}`,
        method: 'post',
        body: {}
      })
    }),
  })
});

export const { useLoginMutation, useImpersonateMutation } = extendedApiSlice;
